import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

/**
 * @description Util for creating the Client for the React Apps within Account
 *
 * @param {{
 *   store: {},
 *   history: {},
 *   destination: HTMLElement,
 *   App: React.Component,
 * }} props
 * @param {Object} store Redux Store
 * @param {Object} history React Router history object
 * @param {object} App App component containing all client-side routes/components
 * @param {HTMLElement} destination Root DOM node to mount React to
 * @param {Object} identity Split/Segment Identity
 */
export const mount = ({ // eslint-disable-line import/prefer-default-export
  store, history, destination, App, identity
}) => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App identity={identity} />
      </ConnectedRouter>
    </Provider>,
    destination
  );
};
